import { createFileRoute } from "@tanstack/react-router";
import { LoginCard } from "@/components/login-card";

export const Route = createFileRoute("/auth")({
  ssr: false,
  head: () => ({ meta: [{ title: "Sign in — Studio OS" }] }),
  component: AuthPage,
});

function AuthPage() {
  return (
    <LoginCard
      title="Studio OS"
      subtitle="Sign in to your studio workspace"
      audience="studio"
      allowedRoles={["org_owner", "org_admin", "org_member"]}
      demoAccounts={[
        { label: "Studio owner", email: "owner@thornestudio.test" },
        { label: "Studio editor", email: "editor@thornestudio.test" },
      ]}
      redirectTo="/"
    />
  );
}
